import React, { Fragment, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { AuthBlock } from './components/authBlock';
import { SearchBar } from './components/searchBar';
import { TaskList } from './components/taskList';
import { IndexedDB } from './lib/indexedDB';
import { YaDisk } from './lib/yandexDisk';


function App() {
    const [searchInput, setSearchInput] = useState(''),
        [taskList, setTaskList] = useState([]),
        [iDB, setIDB] = useState(null),
        [yaDisk, setYaDisk] = useState(null),
        [isAuthorized, setIsAuthorized] = useState(window.localStorage.isAuthorized === 'true');

    useEffect(() => {
        new IndexedDB()
            .then(iDB => { setIDB(iDB); return iDB })
            .then(iDB => iDB.getAll('list'))
            .then(taskList => setTaskList(taskList));
    }, []);

    useEffect(() => {
        if (iDB && window.localStorage.authService === 'yandex') {
            new YaDisk()
                .then(yaDisk => {
                    setYaDisk(yaDisk);
                    setIsAuthorized(yaDisk.isAuthorized);
                    syncData(yaDisk);
                });
        }
    }, [iDB]);

    function logout() {
        setYaDisk(yaDisk => yaDisk.logout());
        setIsAuthorized(false);
    }

    async function syncData(yaDisk) {
        const fileName = 'dataBase.json';
        const localLastEdited = window.localStorage.lastEdited;
        let remoteLastEdited = await yaDisk.getMetaModified(fileName);

        if (!localLastEdited || remoteLastEdited > localLastEdited) {
            const downloadLink = await yaDisk.getDownloadLink(fileName);
            const remoteData = await yaDisk.downloadData(downloadLink);
            setTaskList(remoteData);
            iDB.clear('list');
            iDB.setAll('list', remoteData, remoteLastEdited);
        } else if (remoteLastEdited < localLastEdited) {
            const uploadLink = await yaDisk.getUploadLink(fileName);
            const localData = await iDB.getAll('list');
            await yaDisk.uploadData(uploadLink, localData);
            let remoteLastEdited = await yaDisk.getMetaModified(fileName);
            window.localStorage.setItem('lastEdited', remoteLastEdited);
        }
        console.log('sync done');
    };

    function onChangeData() {
        syncData(yaDisk);
        window.localStorage.setItem('lastEdited', +new Date());
    }

    function handleChange({ ev, type, taskId }) {
        if (type === 'searchInput') {
            setSearchInput(ev.target.value);
        }

        if (type === 'taskNameInput') {
            onChangeData();
            setTaskList(taskList.map(task => {
                if (task.id === taskId) {
                    task.name = ev.target.value;
                }
                return task;
            }));
        }

        if (type === 'taskCheck') {
            onChangeData();
            setTaskList(taskList.map(task => {
                if (task.id === taskId) {
                    task.isChecked = !task.isChecked;
                    iDB.set('list', task, taskId);
                }
                return task;
            }));
        }
    }

    function handleReset() {
        setSearchInput('');
    }

    function handleSubmit(ev) {
        ev.preventDefault();
        if (searchInput.trim()) {
            onChangeData();
            const time = +new Date(),
                task = { id: time, name: searchInput, isChecked: false, state: 'ready' };
            setTaskList([...taskList, task]);
            handleReset();
            iDB.set('list', task, time);
        }
    }

    function handleClick({ taskId, type }) {
        if (type === 'remove') {
            onChangeData();
            setTaskList(taskList.filter(task => task.id !== taskId));
            iDB.delete('list', taskId);
        }

        if (type === 'edit') {
            setTaskList(taskList.map(task => {
                if (task.id === taskId) {
                    task.state = 'editing';
                }
                return task;
            }));
        }
    }

    function handleBlur({ taskId }) {
        onChangeData();
        setTaskList(taskList.map(task => {
            if (task.id === taskId) {
                task.state = 'ready';
                iDB.set('list', task, taskId);
            }
            return task;
        }));
    }

    const authBlockProps = { isAuthorized, logout },
        searchBarProps = { searchInput, handleChange, handleReset, handleSubmit },
        taskListProps = { taskList, handleClick, handleChange, handleBlur };

    return (
        <Fragment>
            <AuthBlock {...authBlockProps} />
            <SearchBar {...searchBarProps} />
            <TaskList {...taskListProps} />
        </Fragment>
    );
}

// ========================================

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('app')
);